<template>
  <el-popover placement="bottom" title="" width="400" trigger="hover" :content="popMes">
    <p slot="reference" class="popMes">{{hoverMes}}</p>
  </el-popover>
</template>

<script>

	export default {
		name: "pop",
		props: {
			popMes: {
				type: String,
				default: ''
			},
      hoverMes: {
        type: String,
        default: ''
      },
      popWidth:{
			  type:Number,
        default:0
      }
		},
		data() {
			return {

			}
		},
		methods: {

		},
		created() {

		}
	}
</script>

<style scoped>
.popMes{
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/list/popover/pop.vue